/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Permissions_CountInputs */

const en_admin_permissions_count = /** @type {(inputs: Admin_Permissions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} permissions defined`)
};

const zh_admin_permissions_count = /** @type {(inputs: Admin_Permissions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 个权限`)
};

/**
* | output |
* | --- |
* | "{count} permissions defined" |
*
* @param {Admin_Permissions_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_count = /** @type {((inputs: Admin_Permissions_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_count(inputs)
	return zh_admin_permissions_count(inputs)
});
export { admin_permissions_count as "admin.permissions.count" }